import { useNavigate } from "react-router-dom"
import { Button } from "../components/ui/Button"
import { ApprovedCircled } from "../icons/approvedCircled"
import { mapStepToMessage, mapStepToText } from "../utils/helper"
import usePersonStore from "../store/personStore"


export const SuccessOfferPage = ({ data }) => {
    const navigate = useNavigate()
    const showRetailDashboard = usePersonStore(
        (store) => store.showRetailDashboard
      );
    
    return(
        <div className="container h-full flex  w-full flex-col gap-10 w-full items-center lg:mx-auto">
            <div className="flex flex-col gap-4 items-center pt-8">
                <p className="font-[700] text-[24px]">Συγχαρητήρια!</p>
                <ApprovedCircled/>
                <div className="flex flex-col gap-1 justify-center items-center">
                <p className="font-[500] text-[18px]"> {mapStepToText(data.state.step)}</p>
                <p className="text-sm text-center">{mapStepToMessage(data.state.step, data.state.substatus) ?? data.state.message}</p>
            </div>
            </div>
            <img alt={data.carTitle} src={`https://cdn.imagin.studio/getImage?customer=avis-gr&&make=${data.carTitle.split(' ')[0]}&modelFamily=${data.carTitle.split(' ')[1]}&modelYear=${data.ModelYear}&zoomType=fullScreen&width=400&angle=28`}  className="lg:h-[40%] max-h-[314px]"/>
            <Button onClick={()=> navigate(showRetailDashboard ? '/dashboard': '/portal/my-cars')} className={'text-white bg-[#D4002A] py-3 px-14 rounded-[6px] text-body'}>Επιστροφή</Button>
        </div>
    )
}